module.exports = __webpack_public_path__ + "img/download.c2be70f0.png";